module.exports = __webpack_public_path__ + "img/4.bee8ac27.jpg";